<template>
  <el-dialog :visible.sync="visible" width="650px" :show-close="false" :close-on-click-modal="false"
    custom-class="add-parking-area-dialog" @close="closeDialog">
    <div class="dialog-header">
      <span class="dialog-title">{{ $t('parkingAreaManage.addTitle') }}</span>
      <i class="el-icon-close dialog-close" @click="visible = false"></i>
    </div>

    <div class="dialog-body">
      <el-form ref="form" :model="addParkingAreaInfo">
        <div class="form-row">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>小区</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="addParkingAreaInfo.communityId" placeholder="请选择" class="form-select">
              <el-option v-for="item in communities" :key="item.communityId" :label="item.name"
                :value="item.communityId"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('parkingAreaManage.parkingNum') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model.trim="addParkingAreaInfo.num" :placeholder="$t('parkingAreaManage.inputParkingNum')"
              class="form-input" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('parkingAreaManage.parkingType') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="addParkingAreaInfo.typeCd" :placeholder="$t('parkingAreaManage.selectParkingType')"
              class="form-select">
              <el-option v-for="item in parkingTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-label">
            <span>{{ $t('parkingAreaManage.remark') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model="addParkingAreaInfo.remark" type="textarea" :rows="3"
              :placeholder="$t('parkingAreaManage.remarkPlaceholder')" class="form-input" />
          </div>
        </div>
      </el-form>
    </div>

    <div class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">取消</el-button>
      <el-button class="confirm-btn" @click="saveParkingAreaInfo" :loading="saving">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveParkingArea } from '@/api/car/parkingAreaManageApi'
import { getEffectiveCommunityId } from '@/api/community/communityApi'
import { listCommunitys } from '@/api/community/communityManageApi'

export default {
  name: 'AddParkingArea',
  data() {
    return {
      visible: false,
      saving: false,
      addParkingAreaInfo: {
        num: '',
        typeCd: '',
        remark: '',
        communityId: ''
      },
      parkingTypes: [
        { value: '1001', label: this.$t('parkingAreaManage.aboveGround') },
        { value: '2001', label: this.$t('parkingAreaManage.underground') }
      ],
      communities: []
    }
  },
  methods: {
    open() {
      this.visible = true
      this.resetForm()
      this.loadCommunities()
    },

    closeDialog() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    resetForm() {
      this.addParkingAreaInfo = {
        num: '',
        typeCd: '',
        remark: '',
        communityId: getEffectiveCommunityId()
      }
    },

    async loadCommunities() {
      try {
        const params = {
          page: 1,
          row: 1000
        }
        const res = await listCommunitys(params)
        this.communities = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('load communities error:', error)
      }
    },

    async saveParkingAreaInfo() {
      if (!this.addParkingAreaInfo.num) {
        this.$message.error(this.$t('parkingAreaManage.numRequired'))
        return
      }
      if (!this.addParkingAreaInfo.typeCd) {
        this.$message.error(this.$t('parkingAreaManage.typeRequired'))
        return
      }

      try {
        this.saving = true
        const params = {
          ...this.addParkingAreaInfo
        }

        await saveParkingArea(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        console.error('添加停车场失败:', error)
        this.$message.error(this.$t('parkingAreaManage.addFailed'))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .add-parking-area-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #EBF2FA;
    border-bottom: 1px solid #DCE6F5;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .dialog-title {
      font-size: 16px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 600;
      color: #1D2129;
    }

    .dialog-close {
      font-size: 16px;
      color: #8C9BB4;
      cursor: pointer;

      &:hover {
        color: #1D2129;
      }
    }
  }

  .dialog-body {
    padding: 24px;

    .form-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .form-label {
        width: 86px;
        text-align: right;
        padding-top: 9px;
        flex-shrink: 0;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #1D2129;

        .required-mark {
          color: #FB2C36;
          margin-right: 2px;
        }

        .colon {
          color: #000000;
          margin-left: 2px;
        }
      }

      .form-control {
        flex: 1;
        margin-left: 12px;

        .form-input,
        .form-select {
          width: 100%;

          ::v-deep .el-input__inner {
            border-radius: 10px;
            border: 1px solid #DCE6F5;
            background: #FFFFFF;
            font-family: 'Inter', 'PingFang SC', sans-serif;
            font-size: 14px;
            color: #1D2129;
            height: 38px;
            line-height: 38px;

            &::placeholder {
              color: #8C9BB4;
            }
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 0 24px 24px;

    .cancel-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #0E76FF;
      background: #FFFFFF;
      color: #0E76FF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #E8F3FF;
      }
    }

    .confirm-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: none;
      background: #0E76FF;
      color: #FFFFFF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #1C99FF;
      }
    }
  }
</style>
